import React from "react";
import Ravi from "../assets/Ravi.jpg";
import Prashanth from "../assets/Prashanth.jpg";
import Location from "../assets/GoogleLocation.JPG";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { FaEnvelope } from "react-icons/fa";

const mdImage = Prashanth;
const ceoImage = Ravi;

const cardStyle = {
  background: "#fff",
  borderRadius: "12px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
  padding: "2rem",
  margin: "1rem",
  flex: 1,
  minWidth: 0,
  boxSizing: "border-box",
};

const containerStyle = {
  fontSize: "1.5rem",
  maxWidth: "1100px",
  margin: "2rem auto",
  padding: "1rem",
  fontFamily: '"Josefin Sans", Sans-serif',
  boxSizing: "border-box",
};

const rowStyle = {
  display: "flex",
  gap: "2rem",
  marginBottom: "2rem",
};

const belowRowStyle = {
  display: "flex",
  gap: "2rem",
};

const formStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
};

const inputStyle = {
  padding: "0.7rem",
  borderRadius: "6px",
  border: "1px solid #ccc",
  fontSize: "1rem",
};

const buttonStyle = {
  padding: "0.7rem",
  borderRadius: "6px",
  border: "none",
  background: "#E34234 ",
  color: "#fff",
  fontWeight: "bold",
  fontSize: "1rem",
  cursor: "pointer",
};

export default function Contact() {
  return (
    <div style={containerStyle}>
      {/* Responsive styles */}
      <style>{`
        @media (max-width: 900px) {
          .contact-row, .contact-below-row {
            flex-direction: column !important;
            gap: 1rem !important;
          }
          .contact-card {
            margin: 0.5rem 0 !important;
            padding: 1.2rem !important;
          }
        }
        @media (max-width: 600px) {
          .contact-row, .contact-below-row {
            flex-direction: column !important;
            gap: 0.5rem !important;
          }
          .contact-card {
            margin: 0.5rem 0 !important;
            padding: 0.7rem !important;
          }
          .contact-img {
            width: 120px !important;
            height: 120px !important;
          }
          .contact-map-img {
            width: 98vw !important;
            height: auto !important;
            max-width: 320px !important;
          }
        }
      `}</style>
      <h2
        style={{ textAlign: "center", marginBottom: "2rem", color: "#13499C" }}
      >
        Pre-Engineered Building Manufacturer Contact Details
      </h2>
      {/* Top Row: Address and MD/CEO */}
      <div className="contact-row" style={rowStyle}>
        {/* Left Card: Address */}
        <div className="contact-card" style={cardStyle}>
          <h2>Our Address</h2>
          <p>
            <b>Akruthi Engineered Building Solutions</b>
            <br />
            <span style={{ fontSize: "1rem", color: "#555" }}>
              (PEB Manufacturer)
              <br /> Sy. No. 104, Arehalli Village,
              <br />
              Attibele-TVS Road Attibele, Hobli,
              <br />
              Anekal Taluk, Bengaluru-562107,
              <br />
              Karnataka, India
            </span>
          </p>
        </div>
        {/* Right Card: MD & CEO */}
        <div className="contact-card" style={cardStyle}>
          <div style={{ display: "flex", alignItems: "center", gap: "2rem", flexWrap: "wrap", justifyContent: "center" }}>
            <div style={{ textAlign: "center" }}>
              <img
                src={mdImage}
                alt="MD"
                className="contact-img"
                style={{
                  width: 160,
                  height: 160,
                  borderRadius: "50%",
                  marginBottom: 8,
                  objectFit: "cover",
                }}
              />
              <div style={{ fontWeight: "bold" }}>Mr. Prashanth Kumar</div>
              <div
                style={{
                  fontSize: "0.9rem",
                  color: "#888",
                  fontFamily: '"Josefin Sans", Sans-serif',
                }}
              >
                Managing Director
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "0.3em",
                    marginLeft: "0.5em",
                    justifyContent: "center",
                  }}
                >
                  <FaEnvelope style={{ marginRight: 4 }} />
                  <span>prashanth@akruthipeb.com</span>
                </div>
              </div>
            </div>
            <div style={{ textAlign: "center" }}>
              <img
                src={ceoImage}
                alt="CEO"
                className="contact-img"
                style={{
                  width: 160,
                  height: 160,
                  borderRadius: "50%",
                  marginBottom: 8,
                  objectFit: "cover",
                }}
              />
              <div style={{ fontWeight: "bold" }}>Mr. Ravichandra</div>
              <div
                style={{
                  fontSize: "0.9rem",
                  color: "#888",
                  fontFamily: '"Josefin Sans", Sans-serif',
                }}
              >
                Chief Executive Officer
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "0.3em",
                    marginLeft: "0.5em",
                    justifyContent: "center",
                  }}
                >
                  <FaEnvelope style={{ marginRight: 4 }} />
                  <span>ravichandra@akruthipeb.com</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Below Row: Contact Form and Map */}
      <div className="contact-below-row" style={belowRowStyle}>
        {/* Left: Contact Form */}
        <div className="contact-card" style={{ ...cardStyle, flex: 1 }}>
          <h3 style={{ color: "#E34234 " }}>Contact Us</h3>
          <form style={formStyle} onSubmit={(e) => e.preventDefault()}>
            <input
              style={inputStyle}
              type="text"
              placeholder="Your Name"
              required
            />
            <input
              style={inputStyle}
              type="email"
              placeholder="Your Email"
              required
            />
            <input style={inputStyle} type="tel" placeholder="Your Phone" />
            <textarea
              style={{ ...inputStyle, minHeight: 80 }}
              placeholder="Your Message"
              required
            />
            <button style={buttonStyle} type="submit">
              Send Message
            </button>
          </form>
        </div>
        {/* Right: Google Map */}
        <div
          className="contact-card"
          style={{
            ...cardStyle,
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <h3 style={{ color: "#E34234 " }}>Our Location</h3>
          <Zoom>
            <img
              src={Location}
              alt="Location"
              className="contact-map-img"
              width={400}
              height={250}
              style={{ marginBottom: 8, cursor: "zoom-in", maxWidth: "100%", height: "auto", borderRadius: 8 }}
            />
          </Zoom>
        </div>
      </div>
    </div>
  );
}
